module.exports = __webpack_public_path__ + "media/barometer/lit-fin-ethics-a6bc715c.png";